var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilityWater64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_11124)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0045 43.7031C50.5495 46.4879 52.0545 48.6094 52.5196 50.0676C53.2172 52.2548 52.6038 54.1359 50.795 55.4747C48.9861 56.8135 47.1101 56.878 45.2141 55.4747C43.3181 54.0714 42.8048 52.2144 43.4895 50.0676C43.946 48.6364 45.451 46.5149 48.0045 43.7031Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1997 19.7027V13.3027H28.7997V19.7027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1997 19.7027V13.3027H28.7997V19.7027",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5645 8.50293H23.4351C21.9797 8.50293 20.7998 9.57745 20.7998 10.9029C20.7998 12.2284 21.9797 13.3029 23.4351 13.3029H40.5645C42.0199 13.3029 43.1998 12.2284 43.1998 10.9029C43.1998 9.57745 42.0199 8.50293 40.5645 8.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4073 19.4873H8V30.2423H41.9713V35.7033H54.4V23.2762C54.4 21.1836 52.6181 19.4873 50.42 19.4873H42.4073Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9333 35.7031H41.0667C40.4776 35.7031 40 36.2762 40 36.9831V39.2231C40 39.93 40.4776 40.5031 41.0667 40.5031H54.9333C55.5224 40.5031 56 39.93 56 39.2231V36.9831C56 36.2762 55.5224 35.7031 54.9333 35.7031Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_11124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilityWater64);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityWater64.2069f6f812702732cd09fd3202676b90.svg";
export { ForwardRef as ReactComponent };